export default __webpack_public_path__ + "static/media/SingleSource_logo_dark.346042df.png";